module.exports = __webpack_public_path__ + "static/media/cx.aa81bb9e.svg";